<p-toast [style]="{marginTop: '80px'}"></p-toast>
<p-confirmDialog header="Confirmation" icon="pi pi-exclamation-triangle"></p-confirmDialog>
@if (formLoading) {
  <div class="progress-spinner">
    <app-spinner [formLoading]="formLoading"></app-spinner>
  </div>
}

<p-table #pt [value]="listingQualityStatuss" [lazy]="true" (onLazyLoad)="loadLazy($event)" dataKey="qualityTestId"
  selectionMode="single" [(selection)]="listingQualityStatus" (onRowSelect)="onRowSelect($event)" [loading]="loading"
  [paginator]="true" [rows]="100" [rowsPerPageOptions]="[100,500,1000]" showCurrentPageReport="true"
  currentPageReportTemplate="{totalRecords} results. Page {currentPage} of {totalPages}" [totalRecords]="recordTotal"
  sortMode="multiple" [multiSortMeta]="multiSortMeta" styleClass="p-datatable-striped" [ngStyle]="{'width': 'auto'}"
  [resizableColumns]="true" [autoLayout]="true" [responsive]="true">

  <ng-template pTemplate="caption">
    <div class="d-block text-end">
      <div class="d-flex justify-content-between qualitysearch">
        <!--clear filters-->

        <span class="searchbar" [formGroup]="form1" style="">
          <p-multiSelect [options]="properties" formControlName="shortTermRentals" appendTo="body"
          defaultLabel="Select Property" optionLabel="propertyCode" display="chip"></p-multiSelect>
          @for (validation of validationMessages.shortTermRentals; track validation) {
            <span>
              @if (form1.get('shortTermRentals').hasError(validation.type) && (form1.get('shortTermRentals').dirty || form1.get('shortTermRentals').touched)) {
                <small class="p-invalid"
                  >{{validation.message}}
                </small>
              }
            </span>
          }
        </span>
        <div class="d-flex">
          <button pButton pRipple class="p-button-text"
            style="font-size: 80%; padding: 0.643rem 0.75rem !important; margin-right:10px;"
          (click)="reloadPage()">Clear Filters</button>
          <!--add new-->
          <button pButton pRipple class="p-button"
            style="padding: 0.643rem 0.75rem !important; "
          (click)="testQualityStatus()">Run Quality Test</button>
        </div>

        <!--<button pButton pRipple class="p-button-outlined" style="padding: 0.643rem 0.75rem !important;"
      (click)="testAllListingQualityStatus()">Run All Quality Test</button>-->
    </div>
  </div>
</ng-template>
<ng-template pTemplate="header">
  <tr>
    @for (col of columns; track col) {
      <th [pSortableColumn]="col.field" [ngStyle]="{'width': 'auto'}">
        {{col.header}}
        <p-sortIcon [field]="col.field"></p-sortIcon>
      </th>
    }
    <th [ngStyle]="{'width': 'auto'}"></th>
  </tr>
  <tr>
    <th [ngStyle]="{'width': 'auto'}">
      <p-dropdown #aa [style]="{'width':'50px','min-width':'100%'}" [options]="testResultStatusValues" appendTo="body"
        (onChange)="pt.filter($event.value, 'testResultStatus', 'in')" styleClass="p-column-filter"
        placeholder="Filter" [showClear]="true" optionLabel="name" optionValue="value" display="chip">
        <ng-template let-option pTemplate="item">
          <span>{{option.name}}</span>
        </ng-template>
      </p-dropdown>
      <!--<p-multiSelect [options]="testResultStatusValues" formControlName="shortTermRentals" appendTo="body"
    defaultLabel="Select Property" optionLabel="propertyCode" display="chip"></p-multiSelect>-->
  </th>
  <th [ngStyle]="{'width': 'auto'}"><input [style]="{'width':'50px','min-width':'90%'}" pInputText type="text"
  (input)="pt.filter($event.target.value, 'shortTermRentalId', 'in')"></th>
  <th [ngStyle]="{'width': 'auto'}"><input [style]="{'width':'50px','min-width':'90%'}" pInputText type="text"
  (input)="pt.filter($event.target.value, 'testSubjectName', 'in')"></th>
  <th [ngStyle]="{'width': 'auto'}">
    <p-dropdown #aa [style]="{'width':'50px','min-width':'100%'}" [options]="testNameValues" appendTo="body"
      (onChange)="pt.filter($event.value, 'testName', 'in')" styleClass="p-column-filter"
      placeholder="Filter" [showClear]="true" optionLabel="name" optionValue="value">
      <ng-template let-option pTemplate="item">
        <span>{{option.name}}</span>
      </ng-template>
    </p-dropdown>
  </th>
  <th [ngStyle]="{'width': 'auto'}"><input [style]="{'width':'50px','min-width':'90%'}" pInputText type="text"
  (input)="pt.filter($event.target.value, 'testResultValue', 'in')"></th>
  <th [ngStyle]="{'width': 'auto'}"><input [style]="{'width':'50px','min-width':'90%'}" pInputText type="text"
  (input)="pt.filter($event.target.value, 'testResultDesc', 'in')"></th>
  <th [ngStyle]="{'width': 'auto'}"></th>
</tr>
</ng-template>
<ng-template pTemplate="body" let-listingQualityStatus>
  <tr [pSelectableRow]="listingQualityStatus">
    <td [style.background-color]="getResStatusColor(listingQualityStatus.testResultStatus)">
    {{listingQualityStatus.testResultStatus}}</td>
    <td>{{listingQualityStatus.shortTermRentalId}} </td>
    <td>{{listingQualityStatus.testSubjectName}}</td>
    <td>{{listingQualityStatus.testName}}</td>
    <td>{{listingQualityStatus.testResultValue}}</td>
    <td>{{listingQualityStatus.testResultDesc}}</td>
    <td><span style="float:none">
      <a>
        <i class="pi pi-pencil" aria-hidden="true"
          style="color:blue; font-size:110%; padding-right:20px;"
        (click)="onOpenFormEdit(listingQualityStatus)"></i>
      </a>
    </span>
  </td>
</tr>
</ng-template>
</p-table>
